import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { Checkbox } from '../index';

import { WhyContainer, WhyHeading, WhyDropdown, WhyItem } from './styles';

class WhyCharged extends Component {
  static propTypes = {
    userData: PropTypes.instanceOf(Object),
    userProduct: PropTypes.instanceOf(Object),
    userPreferences: PropTypes.instanceOf(Object),
  };

  getProductAmount = () => {
    const { userProduct, userPreferences } = this.props;
    const { product } = userProduct;
    const { guests } = userPreferences;
    const { maxGuests } = product;

    if (maxGuests === 1) {
      return guests / maxGuests;
    }

    return Math.ceil(guests / maxGuests);
  };


  render() {
    const { getProductAmount } = this;
    const { userProduct, userPreferences, userData } = this.props;
    let last24freeDayPass;
    if(userData) {
      last24freeDayPass = userData.last24freeDayPass;
    }

    return (
      <WhyContainer>
        <WhyHeading>Why am I being charged?</WhyHeading>
        <WhyDropdown>
          <WhyItem>
            <Checkbox name="reasonCharged" blue checked={last24freeDayPass} readonly />
            You already have 1 active free pass
          </WhyItem>
          <WhyItem>
            <Checkbox name="reasonCharged" blue checked={moment(userPreferences.date).isAfter(moment().add(1, 'day'))} readonly />
            Check-in date is outside of a 24 hour window
          </WhyItem>
          <WhyItem>
            <Checkbox name="reasonCharged" blue checked={getProductAmount() > 1} readonly />
            More than 1 ticket is selected
          </WhyItem>
          <WhyItem>
            <Checkbox name="reasonCharged" blue checked={userProduct.product.type !== 0} readonly />
            You are reserving a non-day pass product
          </WhyItem>
          {/*<WhyItem>*/}
          {/*  <Checkbox name="reasonCharged" blue />*/}
          {/*  You&apos;ve exceeded your max number of passes per month*/}
          {/*</WhyItem>*/}
        </WhyDropdown>
      </WhyContainer>
    )
  }
}

const mapStateToProps = state => ({
  userData: state.user.userData,
  userProduct: state.userProduct,
  userPreferences: state.userPreferences,
});

export default connect(mapStateToProps)(WhyCharged);
